"use client";

import { ChevronRight } from "lucide-react";
import { useState, type ReactNode } from "react";

/**
 * Lightweight collapsible block без Radix. Используется в длинных формах
 * (Site Content → policy sections / delivery payment methods).
 */
export function CollapsibleSection({
  title,
  subtitle,
  defaultOpen = false,
  actions,
  children,
}: {
  title: ReactNode;
  subtitle?: ReactNode;
  defaultOpen?: boolean;
  actions?: ReactNode;
  children: ReactNode;
}) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className="rounded-md border bg-card overflow-hidden">
      <div className="flex items-center gap-2 px-3 py-2 border-b border-transparent data-[open=true]:border-border" data-open={open}>
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="flex items-center gap-2 flex-1 text-left"
        >
          <ChevronRight
            className={`h-4 w-4 text-muted-foreground shrink-0 transition-transform ${open ? "rotate-90" : ""}`}
          />
          <div className="min-w-0">
            <div className="text-sm font-medium truncate">{title}</div>
            {subtitle && (
              <div className="text-xs text-muted-foreground truncate">
                {subtitle}
              </div>
            )}
          </div>
        </button>
        {actions}
      </div>
      {open && <div className="p-4 space-y-3">{children}</div>}
    </div>
  );
}
